// import { login as haier_login, logout as haier_logout, configUserCenter } from '@haier/fe-stub-usercenter';
import router from '../router/router';
import { getUserCenterConfig } from '../request/userCenterConfig.js';

async function getConfigUserCenter() {
    const localUrl = window.location.protocol + window.location.host;
    const config = getUserCenterConfig();
    
    // 打印环境信息
    console.log('当前环境:', process.env.NODE_ENV);
    console.log('UserCenter配置:', {
        appId: config.appId,
        clientId: config.clientId,
        ssoUrl: config.ssoUrl,
        tokenUrl: config.tokenUrl,
        redirectUri: localUrl
    });
    
    window.__USERCENTER__.configUserCenter({
        clientId: config.clientId, //账号中心clientId
        ssoUrl: config.ssoUrl, //账号中心统一登录页
        appId: config.appId, //开放平台创建应用获取（open.feishu.cn）
        tokenUrl: config.tokenUrl, //集成了账号中心提供的后端服务的地址
        redirectUri: localUrl
    });
}

// ihaier登录
export async function haierLogin(func) {
    // 区分第一次登录还是重定向进入
    const isihaierCode = window.location.href.indexOf('code') > -1;
    await getConfigUserCenter();

    if (!isihaierCode) {
        // 首次登录，直接登录成功或者跳转账号中心
        window.__USERCENTER__
            .login()
            .then((response) => {
                console.log('ihaier token', response.token);
                if (response.token) {
                    func(response.token);
                } else {
                    // 登录失效，跳转ihaier账号中心登录页
                    logout();
                }
            })
            .catch((res) => {
                logout();
            });
    } else {
        // ihaier账号中心登录后重定向跳转进入
        window.__USERCENTER__
            .login({ force: false })
            .then((response) => {
                console.log('ihaier token2', response.token);
                if (response.token) {
                    func(response.token);
                } else {
                    console.log('ihaier没有该账号');
                    router.replace({ path: '/no-access' }, () => {});
                }
            })
            .catch((res) => {
                console.log('ihaier没有该账号1');
                router.replace({ path: '/no-access' }, () => {});
            });
    }
}

// 重新登录
export async function logout() {
    await getConfigUserCenter();
    window.__USERCENTER__.logout();
}
